import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, TextField, Typography } from "@mui/material";
import DataTable from "../../../Components/Table/Table";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import AddButton from "../../../Components/AddButton/AddButton";
import Paginations from "../../../Components/Pagination/Pagination";
import hospitalImage from "./../../../Assets/Hospital/mykare-hospital.png";
import useHospital from "./useHospital";
import HospitalPopUp from "./HospitalPopUp";
import { checkPermission } from "../../../Utils/Permissions";
import { useEffect } from "react";
import { APP_URL } from "../../../Utils/AppConstance";
import RefreshIcon from "../../../Assets/Table/RefreshIcon";

function Hospital({ isModal }) {
  const navigate = useNavigate();
  const handleOpenPopUp = (data) => {
    navigate("/HospitalAddPage", { state: { id: data?.id, isLive: "live" } });
  };

  const {
    hospitalData,
    hospitals,
    page,
    setPage,
    modal,
    setModal,
    handleApprovePopup,
    handleStatusPopup,
    checkedItems,
    setCheckedItems,
    flaggedItems,
    handleDelete,
    departments,
    locations,
    insurance,
    setFilter,
    platform,
  } = useHospital();

  const tableHeader = [
    {
      id: 1,
      headText1: "Hospital Name",
      headText2: "Location",
      headText3: "Approval",
      headText4: "Status",
      headText5: "",
    },
  ];

  const status = [
    {
      name: "Approved",
      value: "APPROVED",
    },
    {
      name: "Pending",
      value: "PENDING",
    },
  ];
  return (
    <Grid
      sx={{
        width: "77%",
        height: "98vh",
        padding: "0px 25px",
      }}
    >
      <HospitalPopUp
        setOpenModal={setModal}
        openModal={modal.isOpen}
        data={modal}
      />

      <Grid
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f9fbfc",
          borderRadius: "15px",
          padding: "20px",
        }}
      >
        <Grid
          lg={12}
          sx={{ height: "100px" }}
          container
          flex={1}
          flexWrap="wrap"
          alignItems={"center"}
        >
          <Grid container justifyContent="space-between" lg={12}>
            <Grid
              item
              lg={2.5}
              width={50}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography
                style={{
                  color: "black",
                  fontWeight: "600",
                  fontSize: "22px",
                  paddingRight: "3px",
                }}
              >
                Hospitals
              </Typography>
              <Grid
                lg={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  width: "40px",
                  height: "30px",
                  borderRadius: "8px",
                  bgcolor: "#ECF1F5",
                }}
              >
                <RefreshIcon />
              </Grid>
              <Grid
                component={"div"}
                lg={4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  width: "120px",
                  height: "36px",
                  borderRadius: "8px",
                  bgcolor: "#414851",
                  fontSize: "14px",
                  color: "white",
                }}
                onClick={() => navigate("/dashBoard")}
              >
                Map View
              </Grid>
            </Grid>

            {/* <Grid mb={2} item md={2}>
              {checkPermission("DB_HOSPITAL_DETAILS_EDIT") && (
                <AddButton
                  labelName={"Add New Hospital"}
                  onClick={handleOpenPopUp}
                  viewHeight={"40px"}
                  borderRadius={"50px"}
                />
              )}
            </Grid> */}
          </Grid>
          <Grid
            lg={12}
            container
            flex={1}
            justifyContent={"space-between"}
            my={1}
            flexWrap="wrap"
            alignItems={"center"}
          >
            <Grid mb={1} item lg={1.5}>
              <DropDown
                placeHolder="Select Status"
                viewHeight={"40px"}
                borderRadius={"8px"}
                borderColor={"red"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                handleSelected={(e, value) => {
                  setFilter((s) => ({ ...s, approved: value?.value }));
                }}
                data={status}
              />
            </Grid>
            <Grid mb={1} item lg={1.5}>
              <DropDown
                placeHolder="City"
                viewHeight={"40px"}
                borderRadius={"8px"}
                borderColor={"red"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                handleSelected={(e, value) => {
                  setFilter((s) => ({ ...s, locationId: value?.id }));
                }}
                data={locations}
              />
            </Grid>
            <Grid mb={1} item lg={1.5}>
              <DropDown
                placeHolder="Category"
                viewHeight={"40px"}
                borderRadius={"8px"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                handleSelected={(e, value) => {
                  setFilter((s) => ({ ...s, departmentId: value?.id }));
                }}
                data={Array.isArray(departments) ? departments : []}
              />
            </Grid>
            <Grid mb={1} item lg={1.5}>
              <DropDown
                placeHolder="Insurance"
                viewHeight={"40px"}
                borderRadius={"8px"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                data={insurance}
                handleSelected={(e, value) => {
                  setFilter((s) => ({ ...s, insuranceId: value?.id }));
                }}
              />
            </Grid>
            <Grid mb={1} item lg={1.5}>
              <DropDown
                placeHolder="Platform"
                viewHeight={"40px"}
                borderRadius={"8px"}
                border={"1px solid #DFE5EE"}
                bgColor="#FFFFFF"
                handleSelected={(e, value) => {
                  setFilter((s) => ({ ...s, platformId: value?.id }));
                }}
                data={platform}
              />
            </Grid>
            <Grid mb={1} item>
              <SearchBar
                width={230}
                placeHolder={"Search..."}
                onChagevalue={(e) =>
                  setFilter((s) => ({ ...s, keyword: e.target.value }))
                }
              />
            </Grid>
            <Grid mb={1} lg={1.5} item>
              {checkPermission("DB_DOCTOR_DETAILS_EDIT") && (
                <AddButton
                  labelName={"Add New"}
                  width={"130px"}
                  onClick={handleOpenPopUp}
                  viewHeight={"40px"}
                  borderRadius={"50px"}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <DataTable
          tableHeader={tableHeader}
          data={hospitals}
          handleEdit={handleOpenPopUp}
          onClick={handleOpenPopUp}
          handleCheckboxChange={handleApprovePopup}
          handleFlaggChange={handleStatusPopup}
          checkedItems={checkedItems}
          flaggedItems={flaggedItems}
          handleDelete={handleDelete}
          isDelete={checkPermission("DB_HOSPITAL_DELETE")}
          isStatus={checkPermission("DB_HOSPITAL_STATUS")}
          isApproval={checkPermission("DB_HOSPITAL_APPROVAL")}
          isEdit={true}
        />
        <Grid
          sx={{ height: "88px", width: "100%" }}
          container
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Paginations
            page={page}
            count={
              hospitalData?.count <= 10
                ? 1
                : Math.ceil(hospitalData?.count / 10)
            }
            paginationData={setPage}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Hospital;
